// extracted by mini-css-extract-plugin
module.exports = {"button":"_1mT-x","disabled":"_2wbxR","formSubmit":"_XSPX","fullWidth":"Qb_bt","stepByStepButton":"_36CHt","spinnerContainer":"_3Md0o","spinnerAppear":"_36ApR","spinner":"_1AT6P"};